import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import emitter from '@/utils/eventBus' // 导入emitter
// import DM from '/src/utils/dm.vue';
// import store from '@/store';
import '@/style/global.less';
import i18n from '@/locales/useI18n'
import 'virtual:svg-icons-register';
import setupDefaultSetting from '@/utils/setupDefaultSetting'

import FcDesigner from '@form-create/antd-designer'
// import 'ant-design-vue/dist/reset.css';

// import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css'

import "@/utils/default-passive-events"
import { message, Modal } from 'ant-design-vue';

// 仅保留「首次加载」版本检测（自适应页面加载完成后执行）
const checkVersion = async () => {
  // 本地开发环境直接跳过
  if (import.meta.env.DEV) return;

  try {
    const oldVersion = localStorage.getItem('appVersion');
    const res = await fetch('/version.json', { cache: 'no-cache' });
    const { version: newVersion } = await res.json();

    // 仅在版本不一致时触发弹窗（首次加载无oldVersion时只存版本，不弹窗）
    if (oldVersion && oldVersion !== newVersion) {
      Modal.confirm({
        title: '新版本提示',
        content: '检测到新版本，是否刷新页面获取最新功能？',
        okText: '立即刷新',
        cancelText: '稍后刷新',
        type: 'info',
        onOk() {
          localStorage.setItem('appVersion', newVersion);
          window.location.reload();
        }
      });
    } else if (!oldVersion) {
      // 首次访问：只存版本，不弹窗
      localStorage.setItem('appVersion', newVersion);
    }
  } catch (error) {
    console.error('版本检测失败：', error);
  }
};

const app = createApp(App)
// app.component('DM', DM);
// app.use(Antd)
app.use(FcDesigner)
app.use(FcDesigner.formCreate)
app.use(router)
// app.use(store)
app.use(i18n)
app.mount('#app');

setupDefaultSetting()

// 关键：仅执行一次版本检测，且等页面完全渲染后（延迟5秒，彻底避开渲染期）
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  checkVersion();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    checkVersion();
  });
}
window.env = import.meta.env.MODE
window.log = console.log

emitter.once('axios_goto_login', () => {
  router.push({ name: 'login' }) // 直接用main.ts里的router，无注入问题
})